import { IInfiniteData } from '../../../../types';

import { IBulkScanInventoriesResponse } from '../../../types';

/**
 * Format the response of the bulk scan inventories list API.
 * This function takes the InfiniteData response and flattens it into a single
 * response object.
 */
export function formatBulkScanInventoriesListResponse(
  data: IInfiniteData<IBulkScanInventoriesResponse> | undefined
): IBulkScanInventoriesResponse {
  if (!data?.pages) {
    return {
      inventories: [],
      missingInventoriesCount: 0,
      pendingInventoriesCount: 0,
      receivedInventoriesCount: 0,
      total: 0,
      unIdentifiedInventoriesCount: 0,
    };
  }
  let total = 0;
  let missingInventoriesCount = 0;
  let pendingInventoriesCount = 0;
  let receivedInventoriesCount = 0;
  let unIdentifiedInventoriesCount = 0;
  const inventories = data.pages.flatMap((page) => {
    total = page.total;
    missingInventoriesCount = page.missingInventoriesCount;
    pendingInventoriesCount = page.pendingInventoriesCount;
    receivedInventoriesCount = page.receivedInventoriesCount;
    unIdentifiedInventoriesCount = page.unIdentifiedInventoriesCount;

    return page.inventories;
  });

  return {
    inventories,
    missingInventoriesCount,
    pendingInventoriesCount,
    receivedInventoriesCount,
    total,
    unIdentifiedInventoriesCount,
  };
}
